interface ErrorMessageProps {
	error: Error | null;
}

export default function ErrorMessage({ error }: ErrorMessageProps) {
	return (
		<span role="alert">
			Error
			{__DEV__ && <pre>{error?.message}</pre>}
		</span>
	);
}
